import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ActivatedRoute } from '@angular/router';
import {
    POST_LOGIN_RETURN_URL_KEY,
    isSafeReturnUrl,
} from '../../utils/auth-return-url.util';

@Component({
    selector: 'vb-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent {
    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
    ) {
        this.rememberReturnUrl();
        this.authService.loginWithRedirect({
            appState: { target: '/post-login' },
        });
    }

    /**
     * Remembers where the user should land after login: an explicit `returnUrl`
     * query param (in-app sign-in links) or, failing that, the same-origin page
     * that linked here (full-page "Log in" links via the referrer). Stored in
     * sessionStorage so it survives the Auth0 redirect and is consumed by the
     * post-login page.
     */
    private rememberReturnUrl(): void {
        const candidate: string | null =
            this.route.snapshot.queryParams['returnUrl'] ?? this.referrerPath();
        if (isSafeReturnUrl(candidate)) {
            sessionStorage.setItem(POST_LOGIN_RETURN_URL_KEY, candidate);
        } else {
            sessionStorage.removeItem(POST_LOGIN_RETURN_URL_KEY);
        }
    }

    private referrerPath(): string | null {
        try {
            if (!document.referrer) return null;
            const url: URL = new URL(document.referrer);
            if (url.origin !== window.location.origin) return null;
            return url.pathname + url.search;
        } catch {
            return null;
        }
    }
}
